export const config = {
  bg_bg: {
    x: 0,
    y: 0,
    scale: 1,
  },
  frame_base: {
    x: 0,
    y: 0,
    scale: 1,
  },
  fs_bg: {
    x: 0,
    y: 0,
    scale: 1,
  },
  fs_tube_1: {
    x: 0,
    y: 0,
    scale: 1,
  },
  fs_tube_2: {
    x: 0,
    y: 0,
    scale: 1,
  },
  intermediate_bg: {
    x: 0,
    y: 0,
    scale: 1,
  },
  reel_fs: {
    x: 0,
    y: -28,
    scale: 1,
  },
}
